<template>
  <div
    class="navigationLoginLog"
    :class="[this.$route.path == '/' ? 'navigationLoginLog-bg' : '']"
  >
    <div class="navigationLoginLog-box">
      <!-- log图片 -->
      <!-- <img class="navigation-log" src="../../assets/img/TopBannerLogo.png" /> -->
      <div class="navigation-nav">
        <!-- 菜单 -->
        <MenuPage v-if="this.$route.path == '/'"></MenuPage>
        <!-- 登录退出 -->
        <div class="login-div">
          <topretrieveProjectSrit :deleteSort="[1, 2, 3, 4]" :alginRight="true">
          </topretrieveProjectSrit>
          <!-- <topretrieveProjectSrit
            :deleteSort="[1, 2, 3, 4]"
            fontColor="#0033cc"
            fontFamily="Microsoft YaHei"
            fontSize="14px"

            :addNavListRight="[
              { name: '测试1', toLink: '' },
              { name: '测试2', toLink: '' },
              { name: '测试3', toLink: '' },
            ]"
            :databaseDefalut="false"
            :isMobileDefault="true"
          ></topretrieveProjectSrit> -->
        </div>
      </div>
    </div>
    <span
      class="navigationLoginLog-bottom"
      v-if="this.$route.path == '/'"
    ></span>
  </div>
</template>
<script>
import topretrieveProjectSrit from "./topretrieveProjectSrit.vue";
// import topretrieveProjectSrit from "@/components/topNavigation.vue";
import MenuPage from "./menuPage.vue";
export default {
  components: {
    topretrieveProjectSrit,
    MenuPage,
  },
  data() {
    return {
      menuList: "",
      cur: 0,
    };
  },
  mounted() {},
  created() {
    //this.cur = localStorage.getItem("navIndex");
  },
  destroyed() {},
  updated() {},
  render() {},
  filters: {},
  computed: {},
  watch: {},
  methods: {
    // 平滑滚动到指定元素
    scrollToElement(event, id) {
      event.preventDefault(); // 阻止默认的锚点跳转行为
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // 平滑滚动到元素
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navigationLoginLog {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  background: #fafafa;
  border-bottom: solid 1px #e1e3e1;

  .navigationLoginLog-box {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    //   log图片
    .navigation-log {
      width: 110px;
      height: 38px;
      margin-top: 10px;
      display: block;
      float: left;
    }
    //   导航
    .navigation-nav {
      display: -webkit-box;
      float: right;

      .login-div {
        margin-top: 9px;
      }
    }
    /deep/.home {
      width: auto !important;
    }
    /deep/.toplogin {
      background: none;
      line-height: 18px;
      border-bottom: none;
    }
  }
  .MarkColor {
    border-bottom: solid 2px #00baff;
  }
}
.navigationLoginLog-bg {
  // background-color: rgba(21, 109, 205, 0.85);
  // border-bottom: solid 1px #FFFFFF;
  // opacity: 0.2;
}
.navigationLoginLog-bottom {
  width: 100%;
  height: 1px;
  display: block;
  background: #fff;
  opacity: 0.2;
  margin-top: -1.5px;
}
</style>